/** @jsx jsx */

import { Dropdown, IconButton, Spacer } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { ORDER_ITEMS, IssueOrderBy, IssueOrderDirection } from './constants';

const Styles = {
  root: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    align-self: baseline;
    flex: 1;
  `,
  orderWrapper: css`
    width: 130px;
  `,
};

type Props = {
  onChangeOrderBy: (orderBy: IssueOrderBy) => void;
  onChangeOrderDirection: (orderDireciton: IssueOrderDirection) => void;
  orderBy: IssueOrderBy;
  orderDirection: IssueOrderDirection;
};

function IssueOrder({
  onChangeOrderBy,
  onChangeOrderDirection,
  orderBy,
  orderDirection,
}: Props) {
  const isAscending = orderDirection === IssueOrderDirection.ASC;

  return (
    <div css={Styles.root}>
      <div css={Styles.orderWrapper}>
        <Dropdown
          aria-label="Issue ordered by"
          getLabelForItem={item => item.label}
          items={ORDER_ITEMS}
          menuAriaLabel="List of issue orders"
          onChange={item => onChangeOrderBy(item.value)}
          placeholder="Choose a order…"
          selectedItem={ORDER_ITEMS.find(item => item.value === orderBy)}
        />
      </div>
      <Spacer width="10px" />
      <IconButton
        color="icon-primary"
        icon={isAscending ? 'arrowSmallUp' : 'arrowSmallDown'}
        label={isAscending ? 'Ascending' : 'Descending'}
        onClick={() =>
          onChangeOrderDirection(
            isAscending ? IssueOrderDirection.DESC : IssueOrderDirection.ASC
          )
        }
        tooltipPosition="southeast"
      />
    </div>
  );
}

export default IssueOrder;
